import React from 'react'
import { Typography, Box, Link } from '@mui/material'
import Tooltip from 'components/Common/ToolTip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

const sx = {
  link: {
    color: "color.blueLight2",
    // marginLeft: "40px",
    ":hover": {
      color: "color.blueLight2"
    }
  },
  learnMore: {
    display: 'inline',
    marginLeft: '4px',
    textDecorationColor: 'white !important'
  },
  markaazInfo: {
    display: "flex",
    marginLeft: "-18px",
    flexDirection: "column",
    marginTop: "22px"
  },
  markaazInfoWrapper: {
    display: "flex",
    color: "#66668F",
    textAlign: "left",
    margin: '-6px 0 15px 18px'
  }
}

const PoweredByEquifax = ({ searchList, showSpinner }) => {
  return (
    <Box sx={sx.markaazInfoWrapper}>
      <Box sx={sx.markaazInfo}>
        <Typography variant="caption">
          Markaaz curates, verifies, and updates data daily from global premium and public data services.&nbsp;
          <Tooltip
            placement="top-center"
            content={
              <Typography variant="body2" color="white">
                Markaaz Directory data is curated from global premium and public sources, including Equifax, public
                records, and user contributory processes.
                <br />
                <br />
                Our proprietary technology verifies and updates this data daily from our global network.
                <br />
                <br />
                <Link
                  href="https://support.markaaz.com/knowledge/data-methodology"
                  rel="noreferrer"
                  target="_blank"
                  underline="hover"
                  sx={sx.learnMore}
                >
                  <Typography component="span" variant="body2B" color="white">
                    Learn more
                  </Typography>
                </Link>{' '}
                about our data methodology.
              </Typography>
            }
          >
            <InfoOutlinedIcon fontSize="large" />
          </Tooltip>
        </Typography><br />
        {(searchList || showSpinner) && (
          <Link
            target="_blank"
            href="https://clearbit.com/"
            sx={sx.link}
            underline="hover"
          >
            <Typography variant='button3'>Logos provided by Clearbit</Typography>
          </Link>
        )}
      </Box>
    </Box>
  )
}

export default PoweredByEquifax
